export enum RESEND_VERIFY_CODE {
  VERIFICATION_CODE_RESEND = 'verification-code-resend',
  VERIFICATION_CODE_RESEND_TIMEOUT = 'verification-code-resend-timeout'
}
